import { alphaSort } from 'vet-bones/utils';

import { DataSourceTableSelectItem } from 'src/constants/dataSourceTable';
import { ProjectVirtualGraphsToCreate } from 'src/containers/ProjectResourceDialog/ProjectVirtualGraphCreationPanel/types';
import { getTablesFromVgsToCreate } from 'src/containers/ProjectVirtualGraphPanel/utils/getTablesFromVgsToCreate';

export const sortVirtualGraphs = (
  virtualGraphsToCreate: ProjectVirtualGraphsToCreate
) =>
  getTablesFromVgsToCreate(virtualGraphsToCreate).sort(
    alphaSort((vg) => {
      return (vg.from as DataSourceTableSelectItem).name;
    })
  );
